/*
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-03-22 08:55:58
 * @LastEditors: may.li
 * @LastEditTime: 2023-04-07 15:08:32
 */
/**
 * 公用 接口的统一出口
 */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

const api = '/api/'

const common = {
    // 上传图片
    imgupload(params) {
        return axios.post('/common/upload/file', qs.stringify(params))
	},
	// 获取分享图, 1商品 2匠人 3直播 4约看
	shareImg(params){
		return axios.get('/home/common/shareimg', { params: params })
	},
	// 原来的支付 20201030
	pay(params) {
        return axios.post('/home/reapal/topay', qs.stringify(params))
	},
	// 上传视频 base64
	base64video(params) {
        return axios.post('/common/upload/base64video', qs.stringify(params))
	},
    chatchatfiles(params) {
        return axios.post('/home/chat/chatfiles', qs.stringify(params))
    },
	// 验证当前用户角色，非匠人非分销商不能扫码
	verfyRole(params){
		return axios.get('/miniprogram/user/verfyRole', { params: params })
	},
	// 二级分销商绑定二维码，输入二维码编号或者扫码
	bindqrcode(params){
		return axios.post('/miniprogram/user/bindqrcode', qs.stringify(params))
	}
}

// 导出接口
export default common
